import * as React from "react";

import { InitialProps, createStore } from "../../store";
import { App } from "../../components/App";

export function EventMasterEditorApp(props: InitialProps) {
  createStore(props);
  return <App />;
}
